import { render, staticRenderFns } from "./previewComponent.vue?vue&type=template&id=f14fc634&"
import script from "./previewComponent.vue?vue&type=script&lang=js&"
export * from "./previewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports